import { render } from "./verraReportTables.vue?vue&type=template&id=52e84046"
import script from "./verraReportTables.vue?vue&type=script&lang=js"
export * from "./verraReportTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__